import React from 'react';
import PropTypes from 'prop-types';
import Formsy from 'formsy-react';
import {
  FloatingLabelInput as Input,
  FloatingLabelTZSelect as TZSelect
} from '../Elements';
import { DthcActions, GlobalNotifications, Intent } from '../Modules';

export default class AccountInfoFields extends React.Component {
  static propTypes = {
    closeHandler: PropTypes.func.isRequired,
    commitUpdate: PropTypes.func.isRequired,
    localUser: PropTypes.object.isRequired,
    onFieldChange: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      submitted: false
    };
    this.onValidSubmit = this.onValidSubmit.bind(this);
    this.onInvalidSubmit = this.onInvalidSubmit.bind(this);
    this.reset = this.reset.bind(this);
  }

  onValidSubmit() {
    this.props.commitUpdate(this.props.closeHandler);
  }

  onInvalidSubmit() {
    GlobalNotifications.show({
      message: 'Unable to update account information',
      intent: Intent.DANGER
    });
  }

  reset() {
    this.props.reset(this.props.closeHandler);
  }

  render() {
    const { localUser, onFieldChange } = this.props;
    const { submitted } = this.state;
    return (
      <div>
        <Formsy.Form
          onValidSubmit={this.onValidSubmit}
          onInvalidSubmit={this.onInvalidSubmit}
          ref='form'
        >
          <Input
            name='first_name'
            label='First Name'
            value={localUser.first_name}
            onChange={e => onFieldChange(e, 'first_name')}
            required
            submitted={submitted}
            validationError='First name is required'
          />
          <Input
            name='last_name'
            label='Last Name'
            value={localUser.last_name}
            onChange={e => onFieldChange(e, 'last_name')}
            required
            submitted={submitted}
            validationError='Last name is required'
          />
          <Input
            name='company_name'
            label='Company Name'
            value={localUser.company_name}
            onChange={e => onFieldChange(e, 'company_name')}
            required
            submitted={submitted}
            validationError='Company name is required'
          />
          <TZSelect
            name='s_time_zone'
            label='Time Zone'
            value={localUser.s_time_zone}
            onChange={e => onFieldChange(e, 's_time_zone')}
            required
            submitted={submitted}
            validationError='Time Zone is required'
          />
        </Formsy.Form>
        <DthcActions save={() => this.refs.form.submit()} reset={this.reset} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/App/AccountInfoFields.js